// extracted by mini-css-extract-plugin
export default {"root":"_1z9n_2jR","messenger":"_2jHQlwMo","whatsapp":"_3WurcoaT","telegram":"_305wydrI","vk":"_2Fi6oBbw","skype":"_20c5-Sc-","viber":"_2bUQepOh"};